module.exports = __webpack_public_path__ + "static/q6answer1_Scandinavian_wishmas-184631b1fddfc67ea29209bd9323817a.jpg";